import React from 'react';
export default function ManageOrganizations() {
  return <h2>Manage Organizations</h2>;
}